module.exports = __webpack_public_path__ + "static/media/doc-icon.0823eba8.svg";